'use client'

import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { forwardRef, Fragment } from 'react'

import { SheetClose, useIsSheet } from '@/src/domains/design-system/components/Sheet'

export const HeaderBasicNavigationLink = forwardRef<
  React.ElementRef<typeof NavigationMenu.Link>,
  React.ComponentPropsWithRef<typeof NavigationMenu.Link>
>((props, ref) => {
  const isSheet = useIsSheet()

  const Wrapper = isSheet ? SheetClose : Fragment
  const wrapperProps = isSheet
    ? ({
        asChild: true,
      } satisfies React.ComponentPropsWithoutRef<typeof SheetClose>)
    : {}

  return (
    <Wrapper {...wrapperProps}>
      <NavigationMenu.Link {...props} ref={ref} />
    </Wrapper>
  )
})

HeaderBasicNavigationLink.displayName = 'HeaderBasicNavigationLink'
